import '@styles/pages/home.scss';

function myConsoleLog(msg) {
    console.log(msg); // eslint-disable-line no-console
}

function updateSelectedDuesButton(dues) {
    jQuery('.sura-btn--dues').removeClass('sura-btn--selected');
    jQuery(`[data-dues="${dues}"]`).addClass('sura-btn--selected');
}

function updateSelectedDuesField(dues) {
    jQuery('input[name="field_plan_dues"]').val(dues);
}

function updatePlanTotalAmount(inputName) {
    jQuery('.sura-plan-form').each((index, form) => {
        const $input = jQuery(jQuery(form).find(`input[name="${inputName}"]`));
        const $span = jQuery(jQuery(form).find('.sura-product-plan-card__amount-money'));
        $span.text($input.val());
    });
}

// Shorthand for $( document ).ready()
jQuery(() => {
    if (jQuery('.sura-btn--dues').length > 0) {
        jQuery('.sura-btn--dues').on('click', function handleBtnClick() {
            const dues = jQuery(this).data('dues');
            const inputName = dues === 1 ? 'field_plan_yearly_cost' : 'field_plan_monthly_cost';
            updatePlanTotalAmount(inputName);
            updateSelectedDuesButton(dues);
            updateSelectedDuesField(dues);
            myConsoleLog('plan details updated');
        });
    }
});
